import React from 'react';
import { FiPackage, FiClock, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import PortalHeader from '../../components/Portal/PortalHeader';
import { usePortalOrders } from '../../hooks/portal/usePortal';
import './HistorialCompras.scss';

const HistorialCompras = () => {
  const { orders, loading } = usePortalOrders();

  if (loading) {
    return (
      <div className="portal-page">
        <PortalHeader />
        <div className="portal-page__loading">Cargando historial...</div>
      </div>
    );
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case 'COMPLETED':
        return <FiCheckCircle />;
      case 'CANCELLED':
        return <FiXCircle />;
      case 'PENDING':
        return <FiClock />;
      default:
        return <FiPackage />;
    }
  };

  const getStatusText = (status) => {
    const statusMap = {
      'PENDING': 'Pendiente',
      'APPROVED': 'Aprobada',
      'COMPLETED': 'Completada',
      'CANCELLED': 'Cancelada'
    };
    return statusMap[status] || status;
  };

  return (
    <div className="portal-page historial-compras">
      <PortalHeader />

      <div className="portal-page__container">
        <h1 className="portal-page__title">
          <FiPackage /> Historial de Compras
        </h1>

        {orders && orders.length > 0 ? (
          <div className="orders-list">
            {orders.map((order) => (
              <div key={order.id} className="order-card">
                <div className="order-card__header">
                  <div className="order-info">
                    <h3 className="order-number">Orden #{order.id}</h3>
                    <span className="order-date">
                      {new Date(order.created_at).toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                  </div>
                  <div className={`order-status status--${order.status.toLowerCase()}`}>
                    {getStatusIcon(order.status)}
                    <span>{getStatusText(order.status)}</span>
                  </div>
                </div>

                <div className="order-card__body">
                  {order.items && order.items.length > 0 && (
                    <div className="order-items">
                      <h4>Productos ({order.items.length})</h4>
                      <div className="items-list">
                        {order.items.map((item, idx) => (
                          <div key={idx} className="order-item">
                            <div className="item-info">
                              <span className="item-name">
                                {item.product_name || `Producto ID: ${item.product_id}`}
                              </span>
                              <span className="item-details">
                                {item.quantity} {item.quantity > 1 ? 'unidades' : 'unidad'} × ${parseFloat(item.unit_price || 0).toFixed(2)}
                              </span>
                            </div>
                            <span className="item-total">
                              ${parseFloat(item.subtotal || 0).toFixed(2)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {order.notes && (
                    <div className="order-notes">
                      <strong>Notas:</strong> {order.notes}
                    </div>
                  )}

                  {order.delivery_address && (
                    <div className="order-delivery">
                      <strong>Dirección de entrega:</strong> {order.delivery_address}
                    </div>
                  )}
                </div>

                <div className="order-card__footer">
                  <div className="order-total">
                    <span className="total-label">Total de la orden:</span>
                    <span className="total-amount">${parseFloat(order.total || 0).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-state__icon">
              <FiPackage />
            </div>
            <h2>No hay compras registradas</h2>
            <p>Aún no has realizado ninguna orden</p>
            <a href="/portal" className="empty-state__btn">
              Comenzar a comprar
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistorialCompras;
